import * as bootstrap from 'bootstrap';

const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));

const tooltipTriggerListCustom = document.querySelectorAll('[data-bs-toggle="custom-container-tooltip"]');
const tooltipListCustom = [...tooltipTriggerListCustom].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl,
    {
        html: true,
        placement: 'bottom',
        /*offset: [0,],*/
        fallbackPlacements: ['top', 'bottom']
    }));


